module.exports = __webpack_public_path__ + "img/wolf-openbag.e4ac7081.png";